var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6962 14.9996H9.13094V10.7605H6.52225V14.9996H1.95703V8.15177C1.95703 7.97177 2.10279 7.82568 2.28312 7.82568C2.46344 7.82568 2.60921 7.97177 2.60921 8.15177V14.3474H5.87007V10.1083H9.78312V14.3474H13.044V8.47786C13.044 8.29786 13.1897 8.15177 13.3701 8.15177C13.5504 8.15177 13.6962 8.29786 13.6962 8.47786V14.9996Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3262 8.15199C15.245 8.15199 15.1641 8.12199 15.1008 8.06166L7.82617 1.10329L0.551496 8.06166C0.421387 8.1859 0.214974 8.18166 0.090409 8.05155C-0.0341562 7.92144 -0.0292649 7.71503 0.100518 7.59047L7.82617 0.200684L15.5515 7.59014C15.6813 7.71471 15.6862 7.92112 15.5616 8.05123C15.4977 8.11808 15.4123 8.15199 15.3262 8.15199Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7171 4.23898C12.5368 4.23898 12.391 4.09289 12.391 3.91289V1.95637H10.4345C10.2542 1.95637 10.1084 1.81029 10.1084 1.63029C10.1084 1.45029 10.2542 1.3042 10.4345 1.3042H13.0432V3.91289C13.0432 4.09289 12.8974 4.23898 12.7171 4.23898Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.355b6773114221696a8bee52755f5324.svg";
export { ForwardRef as ReactComponent };